<div class="container my-4">
  <div class="row">
    <div class="col-12 ">
      <span class="title_header_bar">Login Details</span>
    </div>
  </div>
  <div class="card card_content">
    <div class="row d-flex  align-items-center flex-wrap grid-margin" style="margin-bottom: 1rem !important;">
      <div class="col-md-4">
        <!-- <button type="button" class="btn btn-secondary mr-2" (click)="clearFilter()">
          <i class="fa fa-refresh"></i> Refresh
        </button> -->
        <app-button (refreshClicked)="clearFilter()"></app-button>

        <button type="button" class="btn btn-primary text-nowrap" (click)="goToLoginDetails(0)">
          <i class="fa fa-plus"></i> Add User
        </button>
      </div>
      <div class="col-md-4">
        <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'searchText-mat-field'">
          <mat-label>Search</mat-label>
          <div class="search-input-container">
            <input placeholder="Enter First Name / Last Name / Email" id="search" matInput (keyup)="applyFilter($event)"
              type="text" #searchInput>
          </div>
        </mat-form-field>
      </div>
    </div>

    <div class="table-responsive mt-2 mb-4">
      <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc">

        <ng-container matColumnDef="firstName">
          <mat-header-cell *matHeaderCellDef mat-sort-header="firstName">First Name</mat-header-cell>
          <mat-cell *matCellDef="let dataField">
            <p class="text-truncate txtalign">{{dataField.firstName}}</p>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="lastName">
          <mat-header-cell *matHeaderCellDef mat-sort-header="lastName">Last Name</mat-header-cell>
          <mat-cell *matCellDef="let dataField">
            <p class="text-truncate txtalign">{{dataField.lastName}}</p>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="email">
          <mat-header-cell *matHeaderCellDef mat-sort-header="email">Email</mat-header-cell>
          <mat-cell *matCellDef="let dataField">
            <p class="text-truncate txtalign">{{dataField.email}}</p>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="cellNumber">
          <mat-header-cell *matHeaderCellDef mat-sort-header="cellNumber">Cell Number</mat-header-cell>
          <mat-cell *matCellDef="let dataField">
            <p class="text-truncate txtalign">{{dataField.cellNumber}}</p>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="role">
          <mat-header-cell *matHeaderCellDef mat-sort-header="role">Role</mat-header-cell>
          <mat-cell *matCellDef="let dataField">
            <p class="text-truncate txtalign">{{dataField.role}}</p>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="action">
          <mat-header-cell *matHeaderCellDef mat-sort-header="action">Action</mat-header-cell>
          <mat-cell *matCellDef="let dataField">
            <div class="text-truncate text-center">
              <i style="cursor: pointer;font-size: 18px;color: #9B02DB;" class="fa fa-edit mr-3" title="Edit User"
                (click)="goToLoginDetails(dataField.userId)"></i>
              <i class="fa fa-rotate-right " style="cursor:pointer; font-size:18px; color:#9B02DB;"
                (click)="resetPassword(dataField)" title="Reset Password"></i>
              <i style="cursor: pointer;font-size: 18px;color: #9B02DB;" class="fa fa-trash-can ml-3"
                (click)="deleteUser(dataField)" title="Deactivate User"></i>
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

        <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
        </mat-row>
      </mat-table>
    </div>
    <div *ngIf="data.length===0" class="text-center">
      No Results Found
    </div>


    <div class="table_pagenation" [hidden]="dataSource?.filteredData.length<=50">
      <mat-paginator #paginator [length]="dataSource?.filteredData.length || 0" [pageIndex]="0" [pageSize]="50"
        [pageSizeOptions]="[50, 100]">
      </mat-paginator>
    </div>
  </div>
</div>